import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconRadio: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M22 13c0-3.3-2.7-6-6-6h-5.2l2.1-3.5c.2-.5.1-1.1-.4-1.4-.5-.2-1.1-.1-1.4.4L9 6.1 6.9 2.5c-.3-.5-.9-.6-1.4-.4-.5.3-.6.9-.4 1.4L7.2 7C4.3 7.4 2 9.9 2 13c0 2.6 1.7 4.8 4 5.6V21c0 .6.4 1 1 1s1-.4 1-1v-2h8v2c0 .6.4 1 1 1s1-.4 1-1v-2.4c2.3-.8 4-3 4-5.6zm-6 4H8c-2.2 0-4-1.8-4-4s1.8-4 4-4h8c2.2 0 4 1.8 4 4s-1.8 4-4 4zm-8-2a2 2 0 100-4 2 2 0 000 4zm10-2a2 2 0 11-4 0 2 2 0 014 0z',
      fillRule: 'evenodd',
      clipRule: 'evenodd',
    })
  )
}
